export default __webpack_public_path__ + "static/media/error_filled.1603eb32.svg";